import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useAuth } from "../authUtils";
import { signOut } from 'firebase/auth';
import { database } from '../config';
import {useNavigate} from "react-router-dom";

function Header() {
  const loggedIn = useAuth();
  const history = useNavigate()
  const logout = ()=>{
    signOut(database).then(data=>{
      history('/admin/login')
    })
  }
  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="/home" className="logo"><span className="fontColor">H</span><span className='fontColor-1'>OLLA'S TREKKING</span></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className='navbar-hamburger' />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/home" className='fontColor-3'>HOME</Nav.Link>
            <Nav.Link href="/about"  className='fontColor-3'>ABOUT</Nav.Link>
            <NavDropdown title="TREKS" id="basic-nav-dropdown"  className='fontColor-3'>
              <NavDropdown.Item href="/one-day-trek">One Day Trek</NavDropdown.Item>
              <NavDropdown.Item href="/two-day-trek">Two Day Trek</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/gallery"  className='fontColor-3'>GALLERY</Nav.Link>
            <Nav.Link href="/contact"  className='fontColor-3'>CONTACT US</Nav.Link>
            {loggedIn ? (
              <>
                <a onClick={logout} className="fontColor-4">LOGOUT</a>
              </>
            ) : (
              <Nav.Link href="/admin/login" className='fontColor-3'>LOGIN</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;